<template>
  <div>
    <el-form ref="form" size="mini" :model="data" status-icon :rules="formRules">
      <el-row class="item-title">
        <el-col :span="24">
          <span>进货单是否必须关联采购单</span>
        </el-col>
      </el-row>
      <el-row class="item-content">
        <el-col :span="24">
          <el-form-item prop="isLink">
            <el-radio-group v-model="data.isLink">
              <el-radio label="1">是</el-radio>
              <el-radio label="0">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <span>（选择是，则进货单录入商品明细时，必须从采购单中选择。否则，可以直接录入商品明细）</span>
        </el-col>
      </el-row>
      <el-row class="item-title">
        <el-col :span="24">
          <span>单据是否处理税金</span>
        </el-col>
      </el-row>
      <el-row class="item-content">
        <el-col :span="24">
          <el-form-item prop="disposeTax">
            <el-radio-group v-model="data.disposeTax">
              <el-radio label="1">处理</el-radio>
              <el-radio label="0">不处理</el-radio>
            </el-radio-group>
          </el-form-item>
          <span>（处理，则在采购订单、进货单中显示票据类型供选择，并且列表显示不含税单价和金额）</span>
        </el-col>
      </el-row>
    </el-form>
    <el-alert title="数据保存成功后，需要重新登录才能生效" type="warning" :closable="false" />
    <div class="item-footer">
      <el-button type="primary" size="mini" style="width:80px;" @click="submit">保 存</el-button>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      data: {
        isLinkId: 0,
        isLink: null, //进货单是否必须关联采购单
        disposeTaxId: 0,
        disposeTax: null, //单据是否处理税金
      },
      isNull: false,
      saveData: [],
      formRules: {
        isLink: [{ required: true, message: "请选择" }],
        disposeTax: [{ required: true, message: "请选择" }],
      },
      api: require("@/api/sy/opt").default,
    };
  },
  methods: {
    getData() {
      this.api.list({ Code: "PURCHASE" }).then((res) => {
        
        if (res.Data.length == 0) {
          this.isNull = true;
        }
        res.Data.forEach((item) => {
          switch (item.OptText) {
            case "IsLink":
              this.data.isLinkId = item.OptId;
              this.data.isLink = item.OptValue;
              break;
            case "DisposeTax":
              this.data.disposeTaxId = item.OptId;
              this.data.disposeTax = item.OptValue;
              break;
          }
        });
      });
    },
    submit() {
      let form = this.formValidate();
      form.then((valid) => {
        if (!valid) return;
        this.saveData = [];

        this.saveData.push({
          OptId: this.data.isLinkId,
          Code: "PURCHASE",
          OptValue: this.data.isLink,
          OptText: "IsLink",
        });
        this.saveData.push({
          OptId: this.data.disposeTaxId,
          Code: "PURCHASE",
          OptValue: this.data.disposeTax,
          OptText: "DisposeTax",
        });

        if (this.isNull) {
          this.api.save(this.saveData).then((res) => {
            if (res.Code == 1) {
              this.$message.error(res.Msg);
            } else {
              this.isNull = false;
              this.$message.success("保存成功");
            }
          });
        } else {
          this.api.update(this.saveData).then((res) => {
            if (res.Code == 1) {
              this.$message.error(res.Msg);
            } else {
              this.$message.success("保存成功");
            }
          });
        }
      });
    },
    formValidate() {
      return this.$refs.form
        .validate()
        .then((valid) => {
          return valid;
        })
        .catch(() => {
          this.$notify({
            title: "提示",
            message: "请检查相关字段（红色）填写是否规范",
            type: "warning",
            position: "top-left",
          });
          return false;
        });
    },
  },
};
</script>
<style lang="less" scoped>
.item-title {
  margin-bottom: 10px;
  span {
    font-size: 18px;
    color: #606266;
  }
}
.item-content {
  margin-bottom: 30px;
  span {
    font-size: 14px;
    line-height: 29px;
    float: left;
    margin-right: 12px;
    color: #606266;
  }
}
.item-footer {
  margin-top: 10px;
  padding: 10px 20px 20px;
  text-align: center;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border-top: 1px solid #e4e7ed;
}
.el-alert {
  padding-left: 5px;
  background: #cae2ff;
  color: #606266;
}
.el-form {
  padding: 0px 13px;
}
.el-form-item--mini.el-form-item,
.el-form-item--small.el-form-item {
  margin-bottom: 0px;
  margin-right: 40px;
  float: left;
}
</style>